import Utilities from '../utilities/utilities';
import * as deepmerge from 'deepmerge';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';

const imagesLoaded = require('imagesloaded');


gsap.registerPlugin(ScrollTrigger, SplitText, DrawSVGPlugin, MorphSVGPlugin);

export default class ScrollTriggerGsap {
	/**
	 * @param {string} element - Selector
	 * @param {Object} options - User options
	 */
	constructor(element, options) {
		this.element = element || '[data-scroll]';
		this.defaults = {
			triggers: this.element,
		};
		this.DOM = {
			html: document.documentElement,
			body: document.body,
		};
		this.options = options ? deepmerge(this.defaults, options) : this.defaults;

		// window.addEventListener('DOMContentLoaded', () => {
			this.init();
			this.initEvents(this.options.triggers);
			Utilities.initObserver(this.options.triggers, this.updateEvents);
		// });

		ScrollTrigger.addEventListener('scrollStart', () => {});

		ScrollTrigger.addEventListener('scrollEnd', () => {});

		ScrollTrigger.addEventListener('refreshInit', () => {});

		ScrollTrigger.addEventListener('refresh', () => {});

		window.addEventListener('NAVIGATE_OUT', () => {
			// ScrollTrigger.update();
			ScrollTrigger.refresh();
		});

		window.addEventListener('NAVIGATE_IN', () => {

		});

		window.addEventListener('NAVIGATE_END', () => {

		});

		window.addEventListener('LOADER_COMPLETE', () => {

		});

		// document.documentElement.classList.replace('html-loading','html-loaded');
		window.addEventListener('load', function() {
			console.log('All assets are loaded');
			document.documentElement.classList.replace('html-loading','html-loaded');
		})

		// UPDATE SCROLLTRIGGER
		// if( $('.js-update-scrolltrigger').length ) {
		// 	$('.js-update-scrolltrigger').click(function(){
		// 		setTimeout(function(){
		// 			$(window).trigger('resize');
		// 			ScrollTrigger.update();
		// 			ScrollTrigger.refresh();
		// 		}, 800);
		// 	});
		// }

	}

	/**
	 * Init
	 */
	init() {
		this.DOM.element = document.querySelectorAll(this.element);
	}

	/**
	 * Initialize events
	 * @param {string} triggers - Selectors
	 */
	initEvents(triggers) {
		ScrollTrigger.defaults({
			markers: false,
			ease: 'power3',
		});

		gsap.utils.toArray(triggers).forEach((element) => {



			if (element.dataset.scrollAnimation === 'splittext-chars') {
				this.splitTextAnimationChars(element);
			} else if (element.dataset.scrollAnimation === 'splittext-lines') {
				this.splitTextAnimationLines(element);
			} else if (element.dataset.scrollAnimation === 'rotation') {
				this.rotationAnimation(element);
			} else if (element.dataset.scrollAnimation === 'batch') {
				this.batchAnimation(element);
			} else if (element.dataset.scrollAnimation === 'scale') {
				this.scaleAnimation(element);
			} else if (element.dataset.scrollAnimation === 'draw-svg') {
				this.drawSvgAnimation(element);
			} else if (element.dataset.scrollAnimation === 'background-color') {
				this.backgroundColorAnimation(element);
			} else if (element.dataset.scrollAnimation === 'pin') {
				this.pinAnimation(element);
			} else if (element.dataset.scrollAnimation === 'pin-scuba') {
				this.pinScubaAnimation(element);
			} else if (element.dataset.scrollAnimation === 'pin-horizontal') {
				this.pinHorizontalAnimation(element);
			} else if (element.dataset.scrollAnimation === 'pin-vertical') {
				this.pinVerticalAnimation(element);
			} else if (element.dataset.scrollAnimation === 'pin-image-sequence') {
				this.pinImageSequence(element);
			} else if (element.dataset.scrollAnimation === 'pin-image-detail') {
				this.pinImageDetail(element);
			} else if (element.dataset.scrollAnimation === 'comparison') {
				this.comparisonAnimation(element);
			} else if (element.dataset.scrollAnimation === 'parallax') {
				this.parallaxAnimation(element);
			} else if (element.dataset.scrollAnimation === 'video') {
				this.videoAnimation(element);
			} else if (element.dataset.scrollAnimation === 'images-pinned') {
				this.imagesPinnedAnimation(element);
			} else {
				this.defaultAnimation(element);
			}

		});
	}


	/**
	 * default Animation
	*/
	defaultAnimation(item) {

		ScrollTrigger.create({
			trigger: item,
			start: 'top 90%',
			toggleClass: 'is-inview',
			toggleActions: 'play none none none',
			// markers: true,
			once: true,
		});

	}

	/**
	 * splitText Animation Chars
	*/
	splitTextAnimationChars(item) {

		gsap.set(item, { autoAlpha: 1 });

		const splitText = new SplitText(item, {
			type: 'chars, words',
		});
		const target = splitText.chars;
		const targetScrub = parseInt(item.dataset.scrollScrub, 10);

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				start: 'top 100%',
				end: 'bottom 60%',
				scrub: targetScrub || false,
				toggleActions: 'play none none none',
			},
		});

		tl.from(target, {
			opacity: 0,
			stagger: 0.5,
			duration: 0.5,
			ease: 'power2.inOut',
		});
	}

	/**
	 * splitText Animation Lines
	*/
	splitTextAnimationLines(item) {

		gsap.set(item, { autoAlpha: 1 });

		const splitText = new SplitText(item, {
			type: 'lines',
		});
		const target = splitText.lines;
		const targetScrub = parseInt(item.dataset.scrollScrub, 10);

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				start: 'top 95%',
				end: 'bottom 50%',
				scrub: targetScrub || false,
				// markers: true,
				toggleActions: 'play none none none',
			},
		});

		tl.from(target, {
			y: 20,
			opacity: 0,
			stagger: 0.8,
			duration: 2.5,
			ease: 'power2.inOut',
		});
	}

	/**
	 * rotation Animation
	*/
	rotationAnimation(item) {

		gsap.set(item, { autoAlpha: 1 });

		const targetScrub = parseInt(item.dataset.scrollScrub, 10);
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				start: 'top 90%',
				end: 'bottom 80%',
				scrub: targetScrub || false,
				toggleActions: 'play none play reverse',
			},
		});

		tl.from(item, {
			x: 400,
			rotation: 360,
		});
	}


	/**
	 * batch Animation
	*/
	batchAnimation(item) {

		gsap.set(item, { autoAlpha: 1 });

		const target = item.querySelectorAll('.batch-el');
		gsap.set(target, { y: 100, opacity: 0 });

		ScrollTrigger.batch(target, {
			// interval: 0.1, // time window (in seconds) for batching to occur.
			// batchMax: 3, // maximum batch size (targets)
			onEnter: (batch) => gsap.to(batch, {
				opacity: 1, y: 0, stagger: { each: 0.1, grid: [1, 3] }, overwrite: true,
			}),
			// onLeave: (batch) => gsap.set(batch, { opacity: 0, y: -100, overwrite: true }),
			// onEnterBack: (batch) => gsap.to(batch, {
			// 	opacity: 1, y: 0, stagger: 0.1, overwrite: true,
			// }),
			// onLeaveBack: (batch) => gsap.set(batch, { opacity: 0, y: 100, overwrite: true }),
			// you can also define things like start, end, etc.

		});
		ScrollTrigger.addEventListener('refreshInit', () => gsap.set(target, { y: 0 }));
	}

	/**
	 * scale Animation
	*/
	scaleAnimation(item) {

		gsap.set(item, { autoAlpha: 1 });

		const targetScrub = parseInt(item.dataset.scrollScrub, 10);

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				start: 'top 100%',
				end: 'bottom 0%',
				scrub: targetScrub || false,
				toggleActions: 'play none play reverse',
			},
		});

		tl.to(item, {
			scale: 1.5,
		});
	}

	/**
	 * parallax Animation
	*/
	parallaxAnimation(item) {

		gsap.set(item, { autoAlpha: 1 });

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				toggleActions: 'play pause none none',
				scrub: 2,
				ease: 'power4',
			},
		});

		tl.to(item, {
			y: -item.dataset.scrollSpeed * 100 || 0,
			x: -item.dataset.scrollSpeedHorizontal * 100 || 0,
		});
	}

	/**
	 * darwSvg Animation
	*/
	drawSvgAnimation(item) {

		gsap.set(item, { autoAlpha: 1 });

		const target = item.querySelectorAll('path');
		const targetScrub = parseInt(item.dataset.scrollScrub, 10);

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				scrub: targetScrub || false,
				start: 'top 70%',
				end: 'bottom 70%',
				toggleActions: 'play none play reverse',
			},
		});

		tl.from(target, {
			drawSVG: 0,
		});
	}

	/**
	 * backgroundColor Animation
	*/
	backgroundColorAnimation(item) {

		gsap.set(item, { autoAlpha: 1 });

		const target = document.body;
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				scrub: 1,
				toggleActions: 'play reset play reset',
			},
		});

		tl.to(target, {
			backgroundColor: item.dataset.backgroundColor,
			ease: 'power1',
		});
	}

	/**
	 * pin Animation
	*/
	pinAnimation(item) {

		gsap.set(item, { autoAlpha: 1 });

		const target = item.querySelector('[data-scroll-animation-target]');
		const targetElement = item.querySelectorAll('.js-pin__element');
		const targetElementEnd = item.querySelectorAll('.js-pin__end');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: target,
				start: 'center center',
				end: "bottom 70%",
    			endTrigger: targetElementEnd,
				// toggleClass: 'active',
				pinSpacing: true,
				pin: true,
				// pinReparent: true,
				scrub: 2,
				// markers: true,
				// anticipatePin: 1,
			},
		});

		tl.from(targetElement, {
			scale: 0.8,
			transformOrigin: 'center center',
		});
	}


	/**
	 * pin Animation
	*/
	pinScubaAnimation(item) {


		gsap.set(item, { autoAlpha: 1 });

		const target = item.querySelector('[data-scroll-animation-target]');
		const targetElement = item.querySelectorAll('.js-pin-scuba__element');
		const targetFilled = item.querySelectorAll('.js-pin-scuba-filled');
		const targetPressure = item.querySelectorAll('.js-pin-scuba-pressure');


		const targetElementEnd = item.querySelectorAll('.js-pin-scuba__end');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: target,
				start: 'center center',
				end: "bottom 70%",
    			endTrigger: targetElementEnd,
				// toggleClass: 'active',
				pinSpacing: true,
				pin: true,
				// pinReparent: true,
				scrub: 2,
				// markers: true,
				// anticipatePin: 1,
			},
		});

		tl
			.to(targetElement, { scale: 1.1, transformOrigin: 'center center'},'togheter')
			.fromTo(targetFilled, { scaleY: 0, transformOrigin: 'bottom'}, {scaleY: 1},'togheter')
			.to(targetPressure, { rotate: 360 , transformOrigin: 'bottom'},'togheter');


	}

	/**
	 * pin Horizontal Animation
	*/
	pinHorizontalAnimation(item) {

		gsap.set(item, { autoAlpha: 1 });

		// const audioplay = document.createElement('audio');
		// audioplay.setAttribute('src', 'http://wordpress-364601-1334787.cloudwaysapps.com/concept/music/audio.mp3');
		const target = item.querySelector('[data-scroll-animation-target]');
		const targetContainer = item.querySelector('.js-pin-horizontal-container');
		const targetScrub = parseInt(item.dataset.scrollScrub, 10);

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: target,
				start: 'center center',
				end: () => `+=${targetContainer.offsetWidth}`,
				scrub: targetScrub || false,
				pin: true,
				// invalidateOnRefresh: true,
				// anticipatePin: 1,
				// onEnter: () => audioplay.play(),
				// onLeave: () => {
				// 	audioplay.pause();
				// 	audioplay.currentTime = 0;
				// },
				// onEnterBack: () => audioplay.play(),
				// onLeaveBack: () => {
				// 	audioplay.pause();
				// 	audioplay.currentTime = 0;
				// },
			},
		});

		tl.fromTo(targetContainer, { x: 0 }, { x: -targetContainer.getBoundingClientRect().width + target.getBoundingClientRect().width });
	}

	/**
	 * pin Vertical Animation
	*/
	pinVerticalAnimation(item) {

		gsap.set(item, { autoAlpha: 1 });

		const target = item.querySelector('[data-scroll-animation-target]');
		const targetLeft = item.querySelector('.pin-vertical-container-left');
		const targetCenter = item.querySelector('.pin-vertical-container-center');
		const targetRight = item.querySelector('.pin-vertical-container-right');
		const targetScrub = parseInt(item.dataset.scrollScrub, 10);

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: target,
				start: 'center center',
				end: () => `+=${targetLeft.offsetHeight}`,
				scrub: targetScrub || false,
				pin: true,
				// anticipatePin: 1,
			},
		});
		tl.fromTo(targetLeft, { y: 0 }, { y: -targetLeft.offsetHeight + item.offsetHeight }, 'step')
			.fromTo(targetCenter, { y: 0 }, { y: targetCenter.offsetHeight - item.offsetHeight }, 'step')
			.fromTo(targetRight, { y: 0 }, { y: -targetRight.offsetHeight + item.offsetHeight }, 'step');
	}


	/**
	 * pin Image Sequence https://codepen.io/GreenSock/pen/yLOVJxd
	*/
	pinImageSequence(item) {

		gsap.set(item, { autoAlpha: 1 });

		const target = item.querySelector('[data-scroll-animation-target]');
		const canvas = item.querySelector(".js-canvas");
		const targetContainer = item.querySelector(".js-image-sequence-container");
		const targetText = item.querySelector(".js-image-detail-text");
		const targetLabel = item.querySelector(".js-image-sequence-label");
		const targetTitle = item.querySelector(".js-image-sequence-title");

		const context = canvas.getContext("2d");
		const frameCount = parseInt(item.dataset.scrollFrames, 10);
		const framePath = item.dataset.scrollPath;
		const frameCountEnd = frameCount * 3;

		const splitText = new SplitText(targetTitle, {
			type: 'chars, words',
		});
		const splitTextTarget = splitText.chars;


		canvas.width = 900;
		canvas.height = 859;

		const currentFrame = index => (
			`${framePath}/${(index + 1).toString().padStart(4, '0')}.jpg`
  			// `https://www.apple.com/105/media/us/airpods-pro/2019/1299e2f5_9206_4470_b28e_08307a42f19b/anim/sequence/large/01-hero-lightpass/${(index + 1).toString().padStart(4, '0')}.jpg`
		);

		const images = []
		const frames = {
  			frame: 0
		};


		for (let i = 0; i < frameCount; i++) {
			const img = new Image();
			img.src = currentFrame(i);
			images.push(img);
		}

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: target,
				start: 'center center',
				end: '+='+frameCountEnd+'%',
				scrub: 1,
				pin: true,
				// anticipatePin: 1,
			},
		});

		tl
			.fromTo(splitTextTarget,{opacity:1}, { opacity: 0.5, stagger: 0.5, duration: 10, ease: 'linear'},'together')
			.to(targetLabel, { y:-30, opacity: 0, duration: 4, ease: 'power2.inOut'},'together')
			.to(frames, { frame: frameCount - 1, snap: "frame", onUpdate: render, duration: 20},'together')
			.fromTo(splitTextTarget,{opacity:0.5}, { opacity: 0, stagger: 0.5, duration: 2, ease: 'linear'},'-=1');


			// .fromTo(itemTitle, {opacity: 0,scale:1},{ opacity: 1, scale:4},'together')
			// .to(itemTitle, { opacity: 0, scale:10 });

		images[0].onload = render;

		function render() {
			context.clearRect(0, 0, canvas.width, canvas.height);
			context.drawImage(images[frames.frame], 0, 0);
		}




	}

	/**
	 * pin Image Detail
	*/
	pinImageDetail(item) {

		gsap.set(item, { autoAlpha: 1 });

		const target = item.querySelector('[data-scroll-animation-target]');
		const targetContainer = item.querySelector(".js-image-detail-container");
		const targetMedia = item.querySelector(".js-image-detail-media");
		const targetTitle = item.querySelector(".js-image-detail-title");

		const splitText = new SplitText(targetTitle, {
			type: 'chars, words',
		});
		const splitTextTarget = splitText.chars;



		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: target,
				start: 'center center',
				end: '+=200%',
				scrub: 1,
				pin: true,
			},
		});

		tl
			.from(splitTextTarget, { opacity: 0, stagger: 0.3, duration:2.5, ease: 'power2.inOut'},'together')
			.fromTo(targetMedia,{y:100,opacity: 0}, { y: 0,opacity:1,duration:4, ease: 'back.inOut'},'together');


	}




	/**
	 * comparison Animation
	*/
	comparisonAnimation(item) {

		gsap.set(item, { autoAlpha: 1 });

		const target = item.querySelector('[data-scroll-animation-target]');
		const targetMedia = item.querySelectorAll('.js-comparison-after-media');
		const targetImage = item.querySelectorAll('.js-comparison-after-media .comparison__img');
		const targetScrub = parseInt(item.dataset.scrollScrub, 10);

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: target,
				start: 'center center',
				// makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
				end: () => `+=${target.offsetWidth}`,
				scrub: targetScrub || false,
				pin: true,
				// anticipatePin: 1,
			},
			defaults: { ease: 'none' },
		});
			// animate the container one way...
		tl.fromTo(targetMedia, { xPercent: 100, x: 0 }, { xPercent: 0 })
			// ...and the image the opposite way (at the same time)
			.fromTo(targetImage, { xPercent: -100, x: 0 }, { xPercent: 0 }, 0);
	}



	/**
	 * imagesPinned Animation
	*/
	imagesPinnedAnimation(item) {

		gsap.set(item, { autoAlpha: 1 });
		const target = item.querySelector('[data-scroll-animation-target]');
		const targetMoved = item.querySelector('[data-scroll-animation-target-moved]');
		const targetSection = item.querySelectorAll('.js-section');
		var sections = gsap.utils.toArray(targetSection);
		var height = 100 * sections.length;

		var tl = gsap.timeline({
			duration: sections.length,
			scrollTrigger: {
				trigger: item,
				start: "top center",
				end: "+=" + height + "%",
				scrub: 1,
				id: "sections"
			}
		});

		gsap.set(targetMoved, { y: 80 });

		var pinner = gsap.timeline({
			scrollTrigger: {
				trigger: target,
				start: "top top",
				end: "+=" + height + "%",
				scrub: 1,
				pin: target,
				pinSpacing: true,
				id: "pinning",
				onUpdate: (self) => {
					// console.log("progresso:", -Math.floor(self.progress * 100 - 200))
					gsap.to(targetMoved, { y: -Math.floor(self.progress * 100 - 80) });
				},
				// markers: true
			}
		});



		sections.forEach(function (elem, i) {

			console.log(i);
			// doesn't allow links to render
			gsap.set(elem, { position: "absolute", top: 0 });

			tl.from(elem.querySelector(".js-image"), { autoAlpha: 0 }, i);
			tl.from(elem.querySelector(".js-text"), {  yPercent: 200, ease: 'linear' }, i);

			if (i != sections.length - 1) {
				tl.to( elem.querySelector(".js-text"), {  yPercent: -200, ease: 'linear' });
				tl.to(elem.querySelector(".js-image"), { autoAlpha: 0 }, i + 0.75);
			}
		});

	}


	/**
	 * video Animation
	*/
	videoAnimation(item) {

		gsap.set(item, { autoAlpha: 1 });
		const targetVideo = item.querySelector('[data-scroll-animation-target]');

		gsap.timeline({
			scrollTrigger: {
				trigger: item,
				start: 'top bottom',
				end: 'bottom top',
				onEnter: () => targetVideo.play(),
				onLeave: () => {
					targetVideo.pause();
					targetVideo.currentTime = 0;
				},
				onEnterBack: () => targetVideo.play(),
				onLeaveBack: () => {
					targetVideo.pause();
					targetVideo.currentTime = 0;
				},
			},
		});

	}
}
